import React, { useEffect } from "react";
import * as S from "./styles";
import { IconButton, Switch } from "@material-ui/core";
import { useMain, useMainState } from "modules/app/contexts";
import { API } from "shared/services";
import { Link, useHistory } from "react-router-dom";
import { Create } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import moment from "moment";
import { auth } from "../../../../shared/services/firebase";

function RenderEditButton(params) {
  const { row } = params;

  return (
    <Link to={`/app/users/${row.id}`}>
      <IconButton>
        <Create />
      </IconButton>
    </Link>
  );
}

function Users() {
  const { t } = useTranslation(["PasswordRecoveryScreen", "Users", "titles"]);
  const { users, user, company, externalUsers } = useMainState();
  const { updateMainUsers } = useMain();
  const history = useHistory();

  const rows = users.filter((user) => {
    if (user?.status === "active") {
      return user;
    }
  });

  useEffect(() => {
    if (user?.role == "seller") {
      history.push("/app");
    }
  }, [user]);

  useEffect(() => {
    async function loadUsers() {
      const result = await API.get("users");
      updateMainUsers(result.data);
    }
    loadUsers();
  }, []);

  function translateRole(params) {
    const { row } = params;
    return t(`Users:columns.${row.role}`);
  }

  function companyName() {
    return company?.company_teams?.map((team) => {
      return team?.name;
    });
  }

  function externalUser(params) {
    const { row } = params;
    return externalUsers
      ?.map((externalId) => {
        return externalId?.external_id === row?.external_id
          ? externalId?.name
          : "";
      })
      .join("");
  }

  function ActiveUser(params) {
    const { row } = params;
    if (row?.status === "disabled")
      return t("Users:users_status.user_desabled");

    return t("Users:users_status.user_active");
  }

  function lastDate(params) {
    const { row } = params;

    if (row.last_sign_in_at !== null) {
      return moment(`${row.last_sign_in_at}`).format("DD/MM/YYYY");
    }

    return (
      <S.InviteButton
        variant="contained"
        onClick={() => handlesubmit(row.email)}
      >
        {t("Users:buttons.invite")}
      </S.InviteButton>
    );
  }

  function successMessage(email) {
    return toast.success(t("PasswordRecoveryScreen:recovery_alert", { email }));
  }

  function handlesubmit(email) {
    auth
      .sendPasswordResetEmail(email)
      .then(() => successMessage(email))
      .catch(() => toast.error(t(`PasswordRecoveryScreen:errorMessage`)));
  }

  const columns = [
    {
      field: "name",
      headerName: t(`Users:header_name.name`),
      width: 240,
      editable: true,
    },
    { field: "email", headerName: "E-Mail", width: 240, editable: true },
    {
      field: "role",
      headerName: "Perfil",
      width: 200,
      valueGetter: translateRole,
      editable: true,
    },

    {
      field: "team",
      headerName: t("Users:teams.team"),
      width: 200,
      valueGetter: companyName,
      editable: true,
    },

    {
      field: "external_user",
      headerName: t("Users:external.external_user"),
      width: 220,
      valueGetter: externalUser,
      editable: true,
    },

    {
      field: "receive_lead",
      headerName: t(`Users:header_name.receive_lead`),
      width: 200,
      renderCell: renderSwitch,
      editable: true,
    },

    {
      field: "actions",
      headerName: t(`Users:header_name.edit`),
      width: 150,
      renderCell: RenderEditButton,
      editable: true,
    },

    {
      field: "last_sign_in_at",
      headerName: t(`Users:header_name.last_sign_in_at`),
      width: 220,
      renderCell: lastDate,
      editable: true,
    },

    {
      field: "Active/Desabled",
      headerName: t(`Users:users_status.active_and_disabled_user`),
      width: 300,
      valueGetter: ActiveUser,
      editable: true,
    },
  ];

  function renderSwitch(params) {
    const { row } = params;

    async function handleClick(row) {
      updateMainUsers(
        users.map((user) => {
          if (user.id == row.id) {
            return { ...user, receive_lead: !row.receive_lead };
          }

          return { ...user };
        })
      );

      try {
        await API.put(`/users/${row.id}`, {
          user: {
            receive_lead: !row.receive_lead,
          },
        });

        toast.success(t("Users:update_user.update_text"));
      } catch (_e) {
        updateMainUsers(
          users.map((user) => {
            if (user.id == row.id) {
              return { ...user, receive_lead: row.receive_lead };
            }

            return { ...user };
          })
        );

        toast.error(t("Users:update_user.failed_text"));
      }
    }

    return (
      <Switch
        checked={row.receive_lead}
        onClick={() => handleClick(row)}
        color="primary"
      />
    );
  }

  return (
    <S.Container>
      <S.Title>{t("Users:titles.user_listing")}</S.Title>

      <S.UsersTable
        disableSelectionOnClick
        columns={columns}
        rows={rows}
        rowCount={users?.length || 0}
        isCellEditable={false}
        pageSize={10}
        getRowClassName={(params) =>
          `super-app-thme--${params.getValue(params.id, "status")}`
        }
      />
    </S.Container>
  );
}

export default Users;
